import { useState, useEffect } from 'react';
import Navbar from './Navbar';

//import { Carousel, Row } from "react-bootstrap";
import EventData from './data/EventData.json';
//import May from './data/May.json';

import 'bootstrap/dist/css/bootstrap.min.css';
import './css/Events.css';

var images = require.context('./images', true);

function Events() {

  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  var today = new Date();
  var monthNumber = today.getMonth();
  var monthName = monthNames[monthNumber];
  var currentYear = today.getFullYear();
  console.log("Month Outside " + monthName);

  let dateToday = today.getDate();
  console.log("Date " + dateToday);


  const [centreEvent, setCentreEvents] = useState(getCentreEvents());


  function getCentreEvents() {
    let eventListC = [];
    EventData.forEach((eventItem) => {
      if (eventItem.eventSpecial === 'Y') {
        console.log("eventItem.eventMonth " + monthNames.indexOf(eventItem.eventMonth));
        console.log("monthNumber " + monthNumber);
        console.log("eventItem.eventDate " + eventItem.eventDate);
        console.log("dateToday " + dateToday);
        eventListC.push(eventItem);
        if (monthNames.indexOf(eventItem.eventMonth) >= monthNumber && eventItem.eventDate >= dateToday) {
          let dayToday = new Date(eventItem.eventYear, monthNames.indexOf(eventItem.eventMonth), eventItem.eventDate);
          eventItem.eventDay = dayNames[dayToday.getDay()];
//          eventListC.push(eventItem);
          console.log("Eventssss C in " + JSON.stringify(eventItem));
        }
      }
    });

    console.log("Eventssss C Out " + JSON.stringify(eventListC));
    return eventListC;
  }

  return (
    <div className="grid gap-0 row-gap-3">

      <div className="p-5">
        <Navbar />
      </div>


      <table className="table cardDeck">
        <tbody>
          <tr>
            {centreEvent.map(eventItemC => (
              <td><div>
                <img
                  src={images("./" + eventItemC.imagePath)}
                  alt={eventItemC.imageAltName}
                  className="img-fluid"
                />
              </div></td>
            ))}

          </tr>
        </tbody>
      </table>

    </div>
  )
}
export default Events;